import type { IRequest } from '../../../../../common/interfaces/IRequest';
import { ResponsiveCard } from '../../molecules/card/Card';

interface IOsasMraCardProps {
    request?: IRequest;
    userHasOsasMraReferralLetter?: boolean;
}

export function OsasMraCard(props: Readonly<IOsasMraCardProps>) {
    const linksTo = props.userHasOsasMraReferralLetter
        ? ['/mraReferral']
        : [props.request ? '/mraReferral?requestId=' + props.request.id : '/mraReferral'];

    return (
        <ResponsiveCard
            body="Je hebt van de slaaparts een verwijzing voor een MRA-beugel gekregen"
            cardTitle="Verwijzing voor MRA"
            lg={12}
            linksText={['Naar de verwijsbrief']}
            linksTo={linksTo}
        />
    );
}
